import { useCallback } from "react";

interface IProps {
  nameSuborder?: boolean;
  onOrderChanged: (value: string) => void;
}

export const useNicheOrdering = ({ nameSuborder, onOrderChanged }: IProps) => {
  const handleChangeOrder = useCallback(
    (value: string | null) => {
      const newValue = value === "name" && nameSuborder ? "alphabetical_asc" : value;

      onOrderChanged(newValue as string);
    },
    [onOrderChanged, nameSuborder]
  );

  return {
    handleChangeOrder,
  };
};
